import { MonetizationOnOutlined as PaidIcon } from '@mui/icons-material';

const Paid = (): JSX.Element => <PaidIcon fontSize="inherit" />;

export default Paid;
